import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import StickyPhoneButton from '../shared/StickyPhoneButton';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen bg-[#0a0a0a]">
      <ScrollToTop />
      {/* Keyboard users can jump the 17-link nav; visually hidden until focused. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-[#C97B2E] focus:text-[#0a0a0a] focus:px-4 focus:py-2.5 focus:rounded-sm focus:font-body focus:text-sm focus:font-bold focus:uppercase focus:tracking-wider"
      >
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <StickyPhoneButton />
    </div>
  );
}
